export class Quantity {
    constructor(element) {
        this.wrapper = $(element);

        this.setElementClasses();

        this.basketItem = this.wrapper.closest('.' + this.BASKET_ITEM_CLASS);
        this.input = this.wrapper.find('.' + this.INPUT_CLASS);

        this.currentValue = parseInt(this.input.val());
        this.min = parseInt(this.input.attr('min'));
        this.max = parseInt(this.input.attr('max'));

        this.bind();
    }
    setElementClasses() {
        this.BASKET_ITEM_CLASS = 'js-basket_item';
        this.BASKET_ITEM_ROW_CLASS = 'js-basket_item-row';

        this.MINUS_BUTTON_CLASS = 'js-quantity_minus';
        this.PLUS_BUTTON_CLASS = 'js-quantity_plus';

        this.INPUT_CLASS = 'js-quantity_input';

        this.BASKET_ITEM_QUANTITIES_CLASS = 'js-basket_item-quantity_text';
    }
    name() {
        return 'Quantity';
    }
    bind() {
        this.wrapper.find('.' + this.MINUS_BUTTON_CLASS).off('click').on('click', () => this.onChangeClick.call(this, 'minus'));
        this.wrapper.find('.' + this.PLUS_BUTTON_CLASS).off('click').on('click', () => this.onChangeClick.call(this, 'plus'));

        this.input.off('change').on('change', () => this.onChangeValue.call(this));
        this.buttons(this.currentValue)
    }
    buttons(value) {
        if (value == this.min){
            this.wrapper.find('.' + this.MINUS_BUTTON_CLASS).prop('disabled', true);
        } else {
            this.wrapper.find('.' + this.MINUS_BUTTON_CLASS).prop('disabled', false);
        }

        if (value == this.max){
            this.wrapper.find('.' + this.PLUS_BUTTON_CLASS).prop('disabled', true);
        } else {
            this.wrapper.find('.' + this.PLUS_BUTTON_CLASS).prop('disabled', false);
        }
    }
    onChangeClick(type) {
        let newValue = this.currentValue;

        switch (type) {
            case 'minus':
                newValue = Math.max(this.min, (this.currentValue - 1));
                break;

            case 'plus':
                newValue = Math.min(this.max, (this.currentValue + 1));
                break;
        }

        if (this.currentValue !== newValue) {
            this.input.val(newValue);
            this.input.change();
        }
    }
    onChangeValue() {
        let $this = this,
            quantity = parseInt(this.input.val());

        if (isNaN(quantity) || quantity < this.min || quantity > this.max) {
            this.input.val(this.currentValue);

            return;
        }

        const oldValue = this.currentValue;
        const newValue = this.currentValue = quantity;

        this.buttons(newValue);

        $this.basketItem.preloader('show', 'block');
        $('.' + this.BAG_DROP_CLASS).preloader('show', 'block');

        const id = parseInt(this.basketItem.data('id'))

        $.post(
            '/ajax/basket/change_item_quantity/' + this.basketItem.data('item') + '/',
            {quantity: quantity},
            function (result) {
                $this.basketItem
                    .data('quantity', quantity)
                    .attr('data-quantity', quantity);
                    
                $this.basketItem.find('.' + $this.BASKET_ITEM_QUANTITIES_CLASS).text(quantity);

                $this.basketItem.preloader('hide', 'block');
                $('.' + this.BAG_DROP_CLASS).preloader('hide', 'block');

                $this.wrapper.trigger('mario.basket_item.quantity.changed', { oldValue, newValue });

                refreshHeaderBasket();

                window._store.dispatch(window._ActionCreators.setItemQuantityInBasket(id, newValue));
            },
            'json'
        );
    }
}
